module.exports = __webpack_public_path__ + "static/logo-s-591e1443b36e6c4541d20a35b6d6c2cd.png";